import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='stepDelegate' subtitle='ACHUserDetailsStep' mdxType="Item">
      <p>
	Whenever <a href={`#common-api.PrimerHeadlessAchComponent-methods-and-properties.start`}>start</a> or <a href={`#common-api.PrimerHeadlessAchComponent-methods-and-properties.submit`}>submit</a> methods are
	called, <code>stepDelegate</code> will trigger the next step in case the call to the mentioned method was successful.
      </p>
      <p>
	In the case of <code>STRIPE_ACH</code>, the steps will be of type <code>ACHUserDetailsStep</code>.
      </p>
      <p>
	<code>ACHUserDetailsStep</code> is an enum holding different output data for specific steps.
      </p>
      <Group summary='enum ACHUserDetailsStep' mdxType="Group">
    <Item title='retrievedUserDetails(_ details: ACHUserDetails)' mdxType="Item">
        <p>Enum member representing the retrieved user details.</p>
        <Group summary='Properties' open mdxType="Group">
		    <Item title='details' subtitle='ACHUserDetails' mdxType="Item">
                <p>The retrieved user details of type <code>ACHUserDetails</code> previously sent on client session creation.</p>
                <Group summary='Properties' open mdxType="Group">
		            <Item title='firstName' subtitle='String' mdxType="Item">
                        <p>The first name previously sent on client session creation.</p>
			        </Item>
                    <Item title='lastName' subtitle='String' mdxType="Item">
                        <p>The last name previously sent on client session creation.</p>
			        </Item>
                    <Item title='emailAddress' subtitle='String' mdxType="Item">
                        <p>The email address previously sent on client session creation.</p>
			        </Item>
                </Group>
			</Item>
        </Group>
    </Item>
    <Item title='didCollectUserDetails' mdxType="Item">
        Enum member representing the event of collected user details.
    </Item>
      </Group>
      <p>{`Example:`}</p>
      <pre><code parentName="pre" {...{
          "className": "language-swift"
        }}>{`func didReceiveStep(step: PrimerHeadlessStep) {
    guard let step = step as? ACHUserDetailsStep else { return }
    switch step {
    case .retrievedUserDetails(let userDetails):
    case .didCollectUserDetails:
    }
}
`}</code></pre>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      